import React, { useEffect, useState } from "react";
import { CssBaseline, Drawer } from "@mui/material";
import { Outlet } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { batch, useDispatch, useSelector } from "react-redux";
import { BrowserView, isTablet, TabletView } from "react-device-detect";

import i18n from "../i18n-config";
import { listAsyncOffre } from "../store/features/offreSlice";
import { listAsyncBoss } from "../store/features/bossSlice";
import { listAsyncTache } from "../store/features/tacheSlice";
import { listAsyncGrouilleur } from "../store/features/grouilleurSlice";
import { listAsyncSinistre } from "../store/features/sinistreSlice";
import { listAsyncTransaction } from "../store/features/transactionSlice";
import { RootState } from "../store/state";
import { listAsyncUtilisateur } from "../store/features/utilisateurSlice";
import { listAsyncCategorie } from "../store/features/categorieSlice";
import { listAsyncPromotion } from "../store/features/promotionSlice";
import { listAsyncSuperCategorie } from "../store/features/superCategorieSlice";
import SessionExpiredModal from "../components/SessionExpiredModal";
import { CustomAppBar, CustomConfirm, CustomDrawer } from "../components";


const drawerWidth = 250;

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    maxWidth: "100%",
    overflow: "hidden",
  },
}));

interface Props {
  container?: any;
}

const MainLayout: React.FC<Props> = ({ container }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = useState(isTablet ? false : true);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState("");

  const user = useSelector((state: RootState) => state.auth.user);
  const sessionExpired = useSelector((state: RootState) => state.ui.sessionExpired);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const openConfirmModal = (title: string) => {
    setConfirmTitle(title);
    setConfirmModal(true);
  };

  useEffect(() => {
    batch(() => {
      dispatch(listAsyncOffre() as any);
      dispatch(listAsyncBoss() as any);
      dispatch(listAsyncTache() as any);
      dispatch(listAsyncGrouilleur() as any);
      dispatch(listAsyncSinistre() as any);
      dispatch(listAsyncTransaction() as any);
      dispatch(listAsyncUtilisateur() as any);
      dispatch(listAsyncCategorie() as any);
      dispatch(listAsyncPromotion() as any);
      dispatch(listAsyncSuperCategorie() as any);
    })
  }, []);

  return (
    <div>
      <div className={classes.root}>
        <CssBaseline />
        <CustomAppBar
          mobileOpen={mobileOpen}
          user={user}
          handleDrawerToggle={handleDrawerToggle}
          openConfirmModal={openConfirmModal}
        />

        <TabletView>
          <nav className={classes.drawer} style={{ width: 0 }}>
            <Drawer
              container={container}
              variant={"temporary"}
              anchor={"left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
            >
              <CustomDrawer handleDrawerToggle={handleDrawerToggle} />
            </Drawer>
          </nav>
        </TabletView>
        <BrowserView>
          <nav
            className={classes.drawer}
            style={{ width: mobileOpen ? drawerWidth : 0,  }}
          >
            <Drawer
              container={container}
              variant={"persistent"}
              anchor={"left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
            >
              <CustomDrawer handleDrawerToggle={handleDrawerToggle} />
            </Drawer>
          </nav>
        </BrowserView>

        <main className={classes.content}>
          <div className={classes.toolbar} />

          <Outlet />
          <CustomConfirm
            visible={confirmModal}
            onClose={() => setConfirmModal(false)}
            title={i18n.t(confirmTitle)}
          />
          <SessionExpiredModal
            visible={sessionExpired}
          />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
